module.exports = __webpack_public_path__ + "static/media/sudoku_solver.72c398c7.png";